import axios from 'axios';

// Create API URL with dynamic hostname fallback
const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5000`;
};

const API_URL = getApiBaseUrl();

// Axios instance with auth interceptor
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token refresh on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Dispatch custom event for WebSocket cleanup
      window.dispatchEvent(new CustomEvent('tokenChanged', { 
        detail: { action: 'logout' }
      }));
      
      // Force reload to trigger App.js auth check
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

/**
 * Match Service
 */

export const matchService = {
  getMatches: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.team_id) params.append('team_id', filters.team_id);
    if (filters.tournament_id) params.append('tournament_id', filters.tournament_id);
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    
    const response = await api.get(`/api/matches?${params.toString()}`);
    return response.data;
  },

  getMatch: async (id) => {
    const response = await api.get(`/api/matches/${id}`);
    return response.data;
  },

  createMatch: async (matchData) => {
    const response = await api.post('/api/matches', matchData);
    return response.data;
  },

  updateMatch: async (id, matchData) => {
    const response = await api.put(`/api/matches/${id}`, matchData);
    return response.data;
  },

  updateMatchStatus: async (id, status) => {
    const response = await api.patch(`/api/matches/${id}/status`, { status });
    return response.data;
  },

  deleteMatch: async (id) => {
    const response = await api.delete(`/api/matches/${id}`);
    return response.data;
  },

  getMatchStats: async (id) => {
    const response = await api.get(`/api/matches/${id}/stats`);
    return response.data;
  },

  getTeams: async () => {
    const response = await api.get('/api/teams');
    return response.data;
  },

  getTournaments: async () => {
    const response = await api.get('/api/tournaments');
    return response.data;
  },

  getSeasons: async () => {
    const response = await api.get('/api/seasons');
    return response.data;
  },

  getVenues: async () => {
    const response = await api.get('/api/venues');
    return response.data;
  }
};

export default matchService;
